import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AlbumsState } from './albums.state';

export const selectAlbumsState = createFeatureSelector<AlbumsState>('presentationAlbums');

export const selectAllAlbums = createSelector(selectAlbumsState, (state) => state.albums);

export const selectSelectedAlbum = createSelector(selectAlbumsState, (state) => state.selectedAlbum);

export const selectAlbumsLoading = createSelector(selectAlbumsState, (state) => state.loading);

export const selectAlbumsLoadingMore = createSelector(selectAlbumsState, (state) => state.loadingMore);

export const selectHasMoreAlbums = createSelector(selectAlbumsState, (state) => state.hasMore);

export const selectAlbumsError = createSelector(selectAlbumsState, (state) => state.error);

export const selectAlbumsTotal = createSelector(selectAlbumsState, (state) => state.total);

export const selectAlbumsPage = createSelector(selectAlbumsState, (state) => state.page);

export const selectAlbumsQuery = createSelector(selectAlbumsState, (state) => state.query);

export const selectAlbumById = (id: string) =>
  createSelector(selectAllAlbums, (albums) => albums.find((album) => album.id === id));
